import Row2Col from '../Layout/row2col.vue'
import VCell from '../Layout/cell.vue'
import VInput from '../Input/index.vue'
import VSelect from '../Select/index.vue'
import VCheckbox from '../Checkbox/index.vue'
import VRadio from '../Radio/index.vue'
import VAddress from '../Address/index.vue'
import VText from '../Text/index.vue'
import VDatePicker from '../DatePicker/index.vue'
import VDatePickerRange from '../DatePicker/range.vue'
import VSwitch from '../Switch/index.vue'
import VUpload from '../Upload/index.vue'
import VNumberKeyboard from '../Input/numberKeyboard.vue'
import VVerificationCode from '../Input/verificationCode.vue'

export default {
  Row2Col,
  VCell,
  VInput,
  VSelect,
  VCheckbox,
  VRadio,
  VAddress,
  VText,
  VDatePicker,
  VDatePickerRange,
  VSwitch,
  VUpload,
  VNumberKeyboard,
  VVerificationCode
}
